export const DEFAULT_WORKFLOW_OWNER_EMAIL: string = 'technology@sequencehq.com'
